import React, { lazy } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import AccessibleNavigationAnnouncer from './components/AccessibleNavigationAnnouncer'
import PrivateRoute from "functions/react/PrivateRoute";

import {useStores} from "./stores/contexts/StoresContext";

const DashboardLayout = lazy(() => import('./containers/DashboardLayout'))
const SettingsLayout = lazy(() => import('./containers/SettingsLayout'))
const ReportLayout = lazy(() => import('./containers/ReportLayout'))
const Login = lazy(() => import('./pages/Login'))
const Register = lazy(() => import('./pages/Register'))
const Activate = lazy(() => import('./pages/Activate'))
const ActivateNewUser = lazy(() => import('./pages/ActivateNewUser'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const ConfirmPassword = lazy(() => import('./pages/ConfirmPassword'))
const Page404 = lazy(() => import('./pages/404'))

function App() {
  const [state] = useStores();

  function isLoggedInAndCanAccess(area) {
    if (state.user == null || state.user.element_id == null) {
      return false;
    }
    if (area != null) {
      if (area === 'reports' && !state.user.permissions?.includes('analysis')) {
        return false;
      }
      if (area === 'settings' && !state.user.permissions?.includes('user') && !state.user.permissions?.includes('settings')) {
        return false;
      }
    }
    return true;
  }
  
  return (
    <>
    <Router basename={""}>
        <AccessibleNavigationAnnouncer />
        <Switch>
            <Route
              exact
              path="/"
              render={() => {
                return isLoggedInAndCanAccess() ? (
                  <Redirect to="/app/dashboard" />
                ) : (
                  <Redirect to="/app/login" />
                );
              }}
            />
          <Route path="/app/login" component={Login} />
          <Route path="/app/create-account" component={Register} />
          <Route path="/app/activate-account" component={Activate} />
          <Route path="/app/activate-new-account" component={ActivateNewUser} />
          <Route path="/app/forgot-password" component={ForgotPassword} />
          <Route path="/app/confirm-password" component={ConfirmPassword} />

          {/* Place new routes over this */}
          <PrivateRoute
              path={"/app/dashboard"}
              isLoggedIn={isLoggedInAndCanAccess("dashboard")}
              component={DashboardLayout}
            />
            <PrivateRoute
                path={"/app/settings"}
                isLoggedIn={isLoggedInAndCanAccess("settings")}
                component={SettingsLayout}
              />
              <PrivateRoute
                  path={"/app/reports"}
                  isLoggedIn={isLoggedInAndCanAccess("reports")}
                  component={ReportLayout}
                />
          <Route component={Page404} />
        </Switch>
      </Router>
    </>
  )
}

export default App